import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { isBrandViewActive } from '../../../auth/selectors';

const getBaseUrl = (isBarber, isBrand) => {
  if (isBrand) {
    return '/brand/products';
  }

  if (isBarber) {
    return '/barber/products';
  }

  return '/products';
};

const mapStateToProps = state => ({
  barberUser: state.auth.barberUser,
  isBrandUser: isBrandViewActive(state),
});

export default compose(
  connect(mapStateToProps),
  withProps(ownProps => ({
    baseUrl: getBaseUrl(!!ownProps.barberUser, ownProps.isBrandUser),
  }))
);
